import React from "react";
import ReactQRCode from "qrcode.react";

type QRCodeProps = {
  url: string;
};

export function QRCode({ url }: QRCodeProps) {
  return (
    <div>
      <ReactQRCode value={url} />
    </div>
  );
}